export default __webpack_public_path__ + "static/media/Interregular.fcd10405.ttf";